// extracted by mini-css-extract-plugin
export default {"membersHeader":"styles-module__membersHeader__src-labstep-web-components-Group-Card-About-Members-_vgSYp"};